<div class="h-1 border-b border-gray-200" *ngIf="!showSelectedItems">
    <mat-progress-bar *ngIf="!loaded" mode="indeterminate"></mat-progress-bar>
</div>
<div class="flex items-center py-4 pl-2 border-b" *ngIf="showSelectedItems">
    <button class="mr-1" mat-icon-button (click)="hideSelectedItemsPanel()">
        <em class="ti ti-arrow-narrow-left icon-size-7 text-gray-500"></em>
    </button>
    <div class="ml-1 flex items-center">
        <span class="text-lg">{{'dataPicker.quote.selected_quote' | translate}}</span>
        <badge class="ml-2" [options]="getBadgeOptions()">
        </badge>
    </div>
</div>
@if(quotes?.length > 0){
    <div class="overflow-y-auto zuper-scrollbar data-picker-list-content-height">
        @if(associatedQuotes?.length > 0 && isFromNote){
            <div class="flex justify-between items-center" [ngClass]="{'border-b border-gray-200': !isAssociatedExpanded}">
                <div class="text-base primary-font font-normal text-gray-500 py-3 px-5">
                    @if(associatedQuotes.length > 1){
                        {{'text.quotes' | translate}}
                    } @else{
                        {{'quote' | translate}}
                    }
                    {{ notesPickerPreferences[module].label | translate}}
                </div>
                <div class="relative cursor-pointer py-3 px-5 flex items-center space-x-2 text-gray-700 transition-all"
                    (click)="isAssociatedExpanded = !isAssociatedExpanded"
                    [ngClass]="{ 'custom-expanded-top': isAssociatedExpanded }">
                    <div class="flex flex-col items-center text-blue-500">
                        <ng-container *ngIf="!isAssociatedExpanded">
                            <i class="text-base font-medium leading-6 ti ti-chevron-up rotate-180"></i>
                            <i class="-mt-3 text-base font-medium leading-6 ti ti-chevron-down rotate-180"></i>
                        </ng-container>
                        <ng-container *ngIf="isAssociatedExpanded">
                            <i class="text-base font-medium leading-6 ti ti-chevron-up"></i>
                            <i class="-mt-3 text-base leading-6 font-medium ti ti-chevron-down"></i>
                        </ng-container>
                    </div>
                    <span class="text-base font-medium text-blue-500">
                        {{ isAssociatedExpanded ? ('collapse' | translate) : ('expand' | translate) }}
                    </span>
                </div>
            </div>
            @if(isAssociatedExpanded){
                <ul role="list"  class="border-b border-gray-200">
                    <li class="quote-data-picker-list-ele border-b border-gray-200" *ngFor="let quote of associatedQuotes;let index = index">
                        <ng-container *ngTemplateOutlet="quoteTemplate; context: { quote: quote, index:index, isAssociated: true }"></ng-container>
                    </li>
                </ul>
            }
            <div class="text-base primary-font font-normal text-gray-500 py-3 px-5">
                {{'text.picker.association.all.quotes' | translate}}
            </div>
        }
        @if(notesPickerPreferences[module]?.preference?.quote === 'LINKED' && isFromNote){
            <div class="text-base primary-font font-normal text-gray-500 py-3 px-5">
                @if(quotes.length > 0){
                    {{'text.quotes' | translate}}
                } @else{
                    {{'quote' | translate}}
                }
                {{ notesPickerPreferences[module].label | translate}}
            </div>
        }
        <ul role="list" class="divide-y divide-gray-200 " [ngClass]="{ 'data-picker-max-count': isMaxSelectionLimit }"
            *ngIf="quotes.length">
            <li class="quote-data-picker-list-ele" *ngFor="let quote of quotes;let index = index">
                <ng-container *ngTemplateOutlet="quoteTemplate; context: { quote: quote, index:index, isAssociated: false }"></ng-container>
            </li>
        </ul>
    </div>
}
<div class="overflow-hidden data-picker-list-content-height flex flex-col items-center justify-center"
    *ngIf="!quotes.length && loaded && !showSelectedItems">
    <div class="flex flex-col items-center justify-center">
        <img class="w-40 m-auto" src="assets/images/svgs/no_contracts_or_quote_found.svg" alt="No Quotes Found">
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="onSearch">{{'dataPicker.quote.not_found' | translate}}
            '{{searchKey}}'</h4>
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="!onSearch">{{'dataPicker.quote.placeholder' | translate}}
        </h4>
    </div>
</div>

<ng-template #quoteTemplate let-quote="quote" let-index="index" let-isAssociated="isAssociated">
    <div class="hover:bg-gray-50 group relative flex items-center py-3 px-5"
    [ngClass]="{'cursor-pointer': selectOption === 'readOnly'}"
    (click)="selectOption === 'readOnly' ? viewQuoteDetails($event, quote.estimate_uid) : null">
    <a class="-m-1 block flex-1 p-1 picker-data-parent-container">
        <div class="relative flex min-w-0 flex-1 items-center">
            <div class="picker-data-inner-container flex" *ngIf="selectOption === 'multiSelect'">
                <span class="flex items-center justify-center px-1">
                    <input 
                        type="checkbox" 
                        class="picker-data-selection-size" 
                        [id]="isAssociated ? 'quote_data_select_associated_' + index : 'quote_data_select_' + index"
                        (change)="selectQuote($event, quote)" 
                        [checked]="isSelectedQuote(quote)" />
                </span>
                <div class="ml-4 truncate picker-data-value-content">
                    <ng-container *ngTemplateOutlet="quotesContent"></ng-container>
                </div>
            </div>
            <div class="picker-data-inner-container flex" *ngIf="selectOption === 'select'">
                <span class="flex items-center justify-center px-1">
                    <input 
                        type="radio" 
                        class="picker-data-selection-size" 
                        [id]="isAssociated ? 'quote_data_select_associated_' + index : 'quote_data_select_' + index"
                        (change)="selectQuote($event, quote)" 
                        [checked]="isSelectedQuote(quote)" />
                </span>
                <div class="ml-4 truncate picker-data-value-content">
                    <ng-container *ngTemplateOutlet="quotesContent"></ng-container>
                </div>
            </div>
            <ng-container *ngIf="selectOption === 'readOnly'">
                <div class="ml-2 truncate picker-data-value-content">
                    <ng-container *ngTemplateOutlet="quotesContent"></ng-container>
                </div>
            </ng-container>
            <ng-template #quotesContent>
                <div class="w-full flex items-center justify-between">
                    <div class="flex flex-col flex-1 min-w-0">
                        <div class="flex items-center min-w-0">
                            <label class="truncate text-lg font-medium text-gray-900 cursor-pointer" [for]="isAssociated ? 'quote_data_select_associated_' + index : 'quote_data_select_' + index"
                                   matTooltip="{{quote?.prefix ?? ''}}{{quote?.estimate_no ?? ''}} {{quote?.proposal_title ? ' - ' + quote.proposal_title :''}}">
                                {{quote?.prefix ?? ''}}{{quote?.estimate_no ?? ''}} {{quote?.proposal_title ? ' - ' + quote.proposal_title :''}}
                            </label>
                            <span class="ml-2 flex items-center flex-shrink-0" *ngIf="quote?.is_proposal">
                                <img loading="lazy" src="assets/images/svgs/clip_path_group.svg" alt="Clip Path" style="width: 16px; height: 16px;">
                            </span>
                        </div>
                        <label *ngIf="utilityService.hasPermission('product.show_selling_price') && !utilityService.isEmptyOrUndefined(quote?.total)"
                               class="truncate text-base text-gray-500">
                            {{currency + ' ' + (quote?.total | number:digitsInfo)}}
                        </label>
                    </div>
                    <div class="flex-shrink-0 ml-4 self-center">
                        <badge *ngIf="quote?.estimate_status" [options]="getStatusBadgeOptions(quote?.estimate_status)"></badge>
                    </div>
                </div>
            </ng-template>
            <button mat-icon-button class="cursor-pointer ml-auto"
            matTooltip="{{ updateArrowTooltipText(quote.estimate_uid, isAssociated) | translate }}"
            matTooltipPosition="above" *ngIf="!showSpinLoading(quote.estimate_uid, isAssociated)"
                [ngClass]="rotateArrowIcon(quote.estimate_uid, isAssociated)"
                (click)="viewQuoteDetails($event, quote.estimate_uid, isAssociated)">
                <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                    data-mat-icon-type="svg" data-mat-icon-name="x" data-mat-icon-namespace="heroicons_outline">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chevron-down"
                        width="24" height="24" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor"
                        fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none">
                        </path>
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </mat-icon>
            </button>
            <div class="ml-auto py-2.5 h-10" *ngIf="showSpinLoading(quote.estimate_uid, isAssociated)">
                <mat-spinner class="ml-auto data-picker-spinner md:mr-3" [diameter]="18" style="width: 18px;height: 18px"></mat-spinner>
            </div>
        </div>
    </a>
</div>
<div class="p-4 bg-gray-100"
        *ngIf="(('quote_details_' + quote.estimate_uid === quoteEleId && !isAssociated) || ('quote_details_associated_' + quote.estimate_uid === quoteEleId && isAssociated)) && quoteDetails && !isSpinLoading">
        <div class="bg-card rounded relative">
            <a target="_blank" class="hidden" #viewFullDetails
                href="{{viewQuoteFullDetails(quote.estimate_uid)}}"></a>
            <span class="cursor-pointer absolute right-0 pt-1 pr-1 z-50" (click)="viewFullDetails.click($event)"
                matTooltip="{{'text.view_details.new_tab' | translate}}" matTooltipPosition="left">
                <button mat-icon-button>
                    <mat-icon class="text-xl">open_in_new</mat-icon>
                </button>
            </span>
            <div class="text-base">
                <div class="px-2 truncate grid grid-cols-2">
                    <div *ngIf="quoteDetails.customer?.customer_first_name"
                        class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                        <p class="font-medium leading-5 truncate text-gray-500">
                            {{'customer' | translate}}</p>
                        <p class="mt-1 text-gray-900"
                            *ngIf="quoteDetails.customer?.is_deleted === true || !utilityService.hasModuleAccess('CUSTOMER')">
                            {{quoteDetails.customer.customer_first_name}}
                            {{quoteDetails.customer.customer_last_name ?? ''}}</p>
                        <p class="mt-1">
                            <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                [routerLink]="utilityService.getLink('CUSTOMER', quoteDetails.customer.customer_uid)"
                                *ngIf="!quoteDetails.customer?.is_deleted && utilityService.hasModuleAccess('CUSTOMER')">
                                {{quoteDetails.customer.customer_first_name}}
                                {{quoteDetails.customer.customer_last_name ?? ''}}</a>
                        </p>
                    </div>
                    <div *ngIf="quoteDetails.organization"
                        class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                        <p class="font-medium leading-5 truncate text-gray-500">
                            {{'text.organization_name' | translate}}</p>
                        <p class="mt-1 text-gray-900"
                            *ngIf="quoteDetails.organization?.is_deleted === true || !utilityService.hasModuleAccess('ORGANIZATION')">
                            {{quoteDetails.organization?.organization_name}}</p>
                        <p class="mt-1">
                            <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                [routerLink]="utilityService.getLink('ORGANIZATION', quoteDetails.organization.organization_uid)"
                                *ngIf="!quoteDetails.organization?.is_deleted && utilityService.hasModuleAccess('ORGANIZATION')">
                                {{quoteDetails.organization?.organization_name}}</a>
                        </p>
                    </div>
                    <div *ngIf="quoteDetails.property"
                        class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                        <p class="font-medium leading-5 truncate text-gray-500">
                            {{'text.property' | translate}}</p>
                        <p class="mt-1 text-gray-900"
                            *ngIf="quoteDetails.property?.is_deleted === true || !utilityService.hasModuleAccess('PROPERTY')">
                            {{quoteDetails.property?.property_name}}</p>
                        <p class="mt-1">
                            <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                [routerLink]="utilityService.getLink('PROPERTY', quoteDetails.property.property_uid)"
                                *ngIf="!quoteDetails.property?.is_deleted && utilityService.hasModuleAccess('PROPERTY')">
                                {{quoteDetails.property?.property_name}}</a>
                        </p>
                    </div>
                    <div *ngIf="quoteDetails.job"
                        class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                        <p class="font-medium leading-5 truncate text-gray-500">
                            {{'job' | translate}}</p>
                        <p class="mt-1 text-gray-900"
                            *ngIf="quoteDetails.job?.is_deleted === true || !utilityService.hasModuleAccess('JOB')">
                            {{quoteDetails?.job.prefix ?? ''}}{{quoteDetails?.job.work_order_number ?? ''}} -
                            {{quoteDetails?.job.job_title}}</p>
                        <p class="mt-1">
                            <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                [routerLink]="utilityService.getLink('JOB', quoteDetails.job.job_uid)"
                                *ngIf="!quoteDetails.job?.is_deleted && utilityService.hasModuleAccess('JOB')">
                                {{quoteDetails?.job.prefix ?? ''}}{{quoteDetails?.job.work_order_number ?? ''}} -
                                {{quoteDetails?.job.job_title}}</a>
                        </p>
                    </div>
                    <div *ngIf="quoteDetails.estimate_date"
                        class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                        <p class="font-medium leading-5 truncate text-gray-500">
                            {{'text.quote_date' | translate}}</p>
                        <p class="mt-1 text-gray-900">
                            {{quoteDetails.estimate_date_dt ? (quoteDetails.estimate_date_dt | dateformat:null:false:false:null:true) : (quoteDetails.estimate_date | dateformat)}}</p>
                    </div>
                    <div *ngIf="quoteDetails.expiry_date"
                        class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                        <p class="font-medium leading-5 truncate text-gray-500">
                            {{'expiry_date' | translate}}</p>
                        <p class="mt-1 text-gray-900">
                            {{quoteDetails.expiry_date_dt ? (quoteDetails.expiry_date_dt | dateformat:null:false:false:null:true) : (quoteDetails.expiry_date | dateformat)}}</p>
                    </div>
                    <div *ngIf="quoteDetails.created_at"
                        class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                        <p class="font-medium leading-5 truncate text-gray-500">
                            {{'created.at.text' | translate}}</p>
                        <p class="mt-1 text-gray-900">
                            {{quoteDetails.created_at | datetime}}</p>
                    </div>
                </div>
            </div>
            <div class="px-2 py-2 border-t text-base"
                *ngIf="quoteDetails.customer_service_address && (quoteDetails.customer_service_address.street || quoteDetails.customer_service_address.state)">
                <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                    {{'text.service_address' | translate}} </p>
                <div class="px-3">
                    <p *ngIf="quoteDetails.customer_service_address.first_name" class="text-base mb-2">
                        {{quoteDetails.customer_service_address.first_name}}
                        {{quoteDetails.customer_service_address.last_name}}</p>
                    <p *ngIf="quoteDetails.customer_service_address.street" class="text-base mb-2">
                        {{quoteDetails.customer_service_address.street}}</p>
                    <p *ngIf="quoteDetails.customer_service_address.landmark" class="text-base mb-2">
                        {{quoteDetails.customer_service_address.landmark}}</p>
                    <p *ngIf="quoteDetails.customer_service_address.city" class="text-base mb-2">
                        {{quoteDetails.customer_service_address.city}}</p>
                    <p *ngIf="quoteDetails.customer_service_address.state" class="text-base mb-2">
                        {{quoteDetails.customer_service_address.state}}
                        {{quoteDetails.customer_service_address.zip_code ? '- ' +
                        quoteDetails.customer_service_address.zip_code : '' }}</p>
                    <p *ngIf="quoteDetails.customer_service_address.country" class="text-base">
                        {{quoteDetails.customer_service_address.country}}</p>
                </div>
            </div>
            <div class="px-2 py-2 border-t text-base"
                *ngIf="quoteDetails.customer_billing_address && (quoteDetails.customer_billing_address.street || quoteDetails.customer_billing_address.state)">
                <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                    {{'billing.address.text' | translate}} </p>
                <div class="px-3">
                    <p *ngIf="quoteDetails.customer_billing_address.first_name" class="text-base mb-2">
                        {{quoteDetails.customer_billing_address.first_name}}
                        {{quoteDetails.customer_billing_address.last_name}}</p>
                    <p *ngIf="quoteDetails.customer_billing_address.street" class="text-base mb-2">
                        {{quoteDetails.customer_billing_address.street}}</p>
                    <p *ngIf="quoteDetails.customer_billing_address.landmark" class="text-base mb-2">
                        {{quoteDetails.customer_billing_address.landmark}}</p>
                    <p *ngIf="quoteDetails.customer_billing_address.city" class="text-base mb-2">
                        {{quoteDetails.customer_billing_address.city}}</p>
                    <p *ngIf="quoteDetails.customer_billing_address.state" class="text-base mb-2">
                        {{quoteDetails.customer_billing_address.state}}
                        {{quoteDetails.customer_billing_address.zip_code ? '- ' +
                        quoteDetails.customer_billing_address.zip_code : '' }}</p>
                    <p *ngIf="quoteDetails.customer_billing_address.country" class="text-base">
                        {{quoteDetails.customer_billing_address.country}}</p>
                </div>
            </div>
        </div>
</div>
</ng-template>